// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"2d51d9ee","234":"d14140c2","246":"94bc7a4b","536":"eabebedb","537":"53393c79","574":"fa6db7f5","577":"5ea2f4b3","683":"0d7282e4","733":"bd34fc49","742":"55215c91"}[chunkId] + ".chunk.js";
};